<script setup>
import { computed } from 'vue'
import { Tag } from '@aryeo/runway'

import ListingDeliveryStatus from '@/Utils/Listings/ListingDeliveryStatus.js'

const props = defineProps({
  deliveryStatus: {
    type: String,
    required: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
  prefix: {
    type: String,
  },
})

const deliveryStatusOption = computed(() => {
  return Object.values(ListingDeliveryStatus).find(
    (status) => status.value === props.deliveryStatus.toLowerCase()
  )
})

const label = computed(() => {
  if (!deliveryStatusOption.value) {
    return 'No Status'
  }

  return props.prefix
    ? `${props.prefix} ${deliveryStatusOption.value.name}`
    : deliveryStatusOption.value.name
})

const color = computed(() => {
  return deliveryStatusOption.value?.color ?? 'secondary'
})
</script>

<template>
  <Tag :label :color :isSmall />
</template>
